<script>
const axios = require('axios');
export default {
  props:{
    list: String,
    owner: String,

    label: {
      type: String,
      default: null,
      required: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
      required: false,
    },
    style: {
      type: String,
      default: 'btn btn-light',
      required: false,
    },
    filter: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      uuid: null,
      data: null
    }
  },
  watch: {
    uuid(){
      if(this.uuid){
        localStorage.setItem(this.storageKey(), this.uuid)
        this.checkStatus(this.uuid)
      }else{
        localStorage.removeItem(this.storageKey())
      }
    }
  },
  methods: {

    checkStatus(uuid){
      this.isLoading = true
      setTimeout(() => {
        this.requestStatusUpdate(uuid)
      }, 5000)
    },

    requestExport(){
      this.isLoading = true
      axios.get(`${this.basePath()}lists/request_items_export`,  {
        params: {
          list: this.list,
          owner: this.owner,
          filter: this.filter
        }
      }).then(response => {
        console.log(response.data)
        if(response.data.uuid){
          this.uuid = response.data.uuid
        }else{
          this.isLoading = false
        }
      }).catch(error => {
        this.isLoading = false
      }).finally(() => {

      })
    },
    requestStatusUpdate(uuid){
      axios.get(`${this.basePath()}lists/check_request_status`,  {
        params: {
          uuid: uuid,
        }
      }).then(response => {
        this.data = response.data
        if(response.data.status === 'done'){
          this.isLoading = false;
          window.open(`${this.basePath()}lists/get_items_export?uuid=${this.uuid}`, '_blank').focus();
          this.uuid = null
        }else if(response.data.status){
          this.checkStatus(uuid)
        }


      }).catch(error => {
        this.isLoading = false
        this.uuid = null
      }).finally(() => {

      })
    },
    storageKey(){
      return `listExportQ-${this.list}-${this.owner}`
    }
  },
  mounted() {
    let uuid = localStorage.getItem(this.storageKey());
    if(uuid){
      this.uuid = uuid
    }
  }
}
</script>

<template>
  <button @click="requestExport" type="button" class="d-flex gap-2 align-items-center" :disabled="isLoading" :class="style">
    <i class="ph ph-download-simple" v-if="showIcon"></i> {{ this.label || $t('lists: download validated import') }}
    <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
      <span class="visually-hidden">Loading...</span>
    </div>
  </button>
</template>

<style scoped>

</style>